export default {
  // Navbar
  nav_brand: 'CSSBuy Spreadsheet',
  nav_home: 'Startseite',
  nav_articles: 'Artikel',
  nav_categories: 'Kategorien',
  nav_shopping_guide: 'Einkaufsratgeber',
  nav_language: 'Sprache',
  nav_english: 'English',
  nav_portuguese: 'Português',
  nav_german: 'Deutsch',

  // Hero
  hero_title: 'CSSBuy Spreadsheet: Produkte, Verkäufer und hilfreiche Ressourcen entdecken',
  hero_subtitle: 'Finden und organisieren Sie Informationen über Produkte, Verkäufer, QC, Versand und Einkäufe bei CSSBuy an einem Ort. Erkunden Sie unser CSSBuy Spreadsheet und entdecken Sie nützliche Ressourcen, um besser zu recherchieren, bevor Sie kaufen.',
  hero_cta_primary: 'CSSBuy Spreadsheet entdecken',
  hero_cta_secondary: 'Hauptwebsite besuchen',
  hero_trust_1: 'Organisierte Ressourcen',
  hero_trust_2: 'Aktualisierte Guides',
  hero_trust_3: 'Einfache Recherche',
  hero_trust_4: 'Sicherheitsinformationen',
  hero_trust_5: 'Unabhängiger Inhalt',

  // Categories Dropdown
  categories_title: 'Produktkategorien',
  categories_shoes: 'Schuhe',
  categories_hoodies: 'Hoodies',
  categories_tshirts: 'T-Shirts',
  categories_jackets: 'Jacken',
  categories_pants: 'Hosen/Shorts',
  categories_headwear: 'Kopfbedeckung',
  categories_sets: 'Sets',
  categories_underwear: 'Unterwäsche',
  categories_jersey: 'Jersey',
  categories_accessories: 'Accessoires',
  categories_bags: 'Taschen',
  categories_belts: 'Gürtel',
  categories_perfumes: 'Parfüms',
  categories_other: 'Sonstiges',

  // Products Catalog
  products_title: 'Produkte Durchsuchen',
  products_subtitle: 'Durchsuchen Sie unsere kuratierte Produktkollektion von vertrauenswürdigen Verkäufern. Klicken Sie auf einen Artikel, um Details anzusehen und zu kaufen.',
  products_view_all: 'Alle ansehen',

  // Category Buttons
  cat_buttons_title: 'Beliebte Kategorien',
  cat_buttons_subtitle: 'Finden Sie, wonach Sie suchen, und erkunden Sie unsere CSSBuy-Produktauswahl',

  // How It Works
  how_title: 'So funktioniert es',
  how_step1: 'Produkt finden',
  how_step1_desc: 'Durchsuchen Sie Kategorien und finden Sie den gesuchten Artikel',
  how_step2: 'Informationen vergleichen',
  how_step2_desc: 'Vergleichen Sie Preise, Verkäufer und Qualitätsbewertungen',
  how_step3: 'Verkäufer recherchieren',
  how_step3_desc: 'Überprüfen Sie den Ruf und die Historie des Verkäufers',
  how_step4: 'QC prüfen',
  how_step4_desc: 'Analysieren Sie Quality-Check-Fotos vor der Bestätigung',
  how_step5: 'Versand und Kosten prüfen',
  how_step5_desc: 'Berechnen Sie die Gesamtkosten inklusive Versand und Gebühren',
  how_step6: 'Entscheidung treffen',
  how_step6_desc: 'Kaufen Sie sicher basierend auf verifizierten Informationen',

  // Featured Articles
  articles_title: 'CSSBuy Guides & Ressourcen',
  articles_subtitle: 'Nützliche Artikel, die Ihnen helfen, die CSSBuy-Welt zu navigieren',
  articles_read_more: 'Mehr lesen',
  articles_seo_title: 'Was ist CSSBuy Spreadsheet? Kompletter Guide 2026',
  articles_seo_desc: 'Entdecken Sie, wie Sie das CSSBuy Spreadsheet verwenden, um Produkte, vertrauenswürdige Verkäufer zu finden und bei Ihren Einkäufen zu sparen. Kompletter Guide für Anfänger.',

  // Comparison
  comparison_title: 'Warum CSSBuy Spreadsheet verwenden?',
  comparison_header_feature: 'Funktion',
  comparison_header_spreadsheet: 'CSSBuy Spreadsheet',
  comparison_header_manual: 'Manuelle Suche',
  comparison_org: 'Organisation',
  comparison_org_high: 'Hoch',
  comparison_org_low: 'Niedrig',
  comparison_filters: 'Filter',
  comparison_yes: 'Ja',
  comparison_no: 'Begrenzt',
  comparison_compare: 'Vergleich',
  comparison_easy: 'Einfach',
  comparison_hard: 'Schwierig',
  comparison_seller: 'Verkäufer-Recherche',
  comparison_seller_easy: 'Einfach',
  comparison_seller_slow: 'Langsam',
  comparison_discovery: 'Produktentdeckung',
  comparison_discovery_high: 'Hoch',
  comparison_discovery_med: 'Mittel',

  // Safety
  safety_title: 'Recherchieren Sie mit mehr Informationen vor dem Kauf',
  safety_desc: 'Online-Informationen können sich ändern. Preise, Lagerbestand, Verkäufer und Versandkosten sollten immer vor dem Kauf verifiziert werden. Dies ist eine unabhängige Informationsressource.',
  safety_note: 'Überprüfen Sie immer aktuelle Produkt-, Verkäufer-, Preis- und Versandinformationen vor dem Kauf.',

  // FAQ
  faq_title: 'Häufig gestellte Fragen',
  faq_q1: 'Was ist ein CSSBuy Spreadsheet?',
  faq_a1: 'Das CSSBuy Spreadsheet ist ein organisiertes Tool, das Informationen über Produkte, Verkäufer, Preise und Qualitätsprüfungen (QC) auf der CSSBuy-Plattform zusammenfasst. Es ermöglicht Ihnen den Vergleich von Optionen und fundiertere Entscheidungen vor dem Kauf.',
  faq_q2: 'Wie verwendet man das CSSBuy Spreadsheet?',
  faq_a2: 'Sie können das CSSBuy Spreadsheet verwenden, indem Sie Produktkategorien durchsuchen und nach Artikeltyp, Verkäufer oder Preis filtern. Jeder Eintrag enthält normalerweise Links zu Produkten, Verkäuferinformationen und QC-Fotos zur Qualitätsverifizierung.',
  faq_q3: 'Ist CSSBuy seriös?',
  faq_a3: 'CSSBuy ist eine bekannte Einkaufsagentur-Plattform, die den Kauf von Produkten aus China erleichtert. Wie bei jeder Online-Plattform ist es wichtig, Verkäufer und Bewertungen vor dem Kauf zu überprüfen. Diese Website ist eine unabhängige Informationsressource.',
  faq_q4: 'Ist CSSBuy sicher?',
  faq_a4: 'Die Sicherheit hängt davon ab, wie Sie die Plattform nutzen. Recherchieren Sie immer Verkäufer, prüfen Sie QC-Fotos, verwenden Sie sichere Zahlungsmethoden und lesen Sie die Rückgaberegelungen vor dem Kauf.',
  faq_q5: 'Wie viel kostet der CSSBuy Versand?',
  faq_a5: 'Die Versandkosten variieren je nach Gewicht, Abmessungen, Zielort und gewählter Versandmethode. Wir empfehlen, den Versandrechner auf der CSSBuy-Plattform für genaue Schätzungen zu nutzen.',
  faq_q6: 'Was sind QC-Fotos?',
  faq_a6: 'QC-Fotos (Quality Check) sind detaillierte Bilder des Produkts, die im Lager vor dem Versand aufgenommen werden. Sie ermöglichen es Ihnen, Qualität, Farbe, Größe und Details des Artikels vor der Versandfreigabe zu überprüfen.',

  // CTA
  cta_title: 'Bereit, das CSSBuy Spreadsheet zu erkunden?',
  cta_button_1: 'CSSBuy Spreadsheet entdecken',
  cta_button_2: 'Hauptwebsite besuchen',

  // Footer
  footer_resources: 'Ressourcen',
  footer_spreadsheet: 'Spreadsheet',
  footer_guides: 'Guides',
  footer_safety: 'Sicherheit',
  footer_disclaimer: 'Disclaimer',
  footer_legal: 'Rechtliches',
  footer_privacy: 'Datenschutz',
  footer_terms: 'Bedingungen',
  footer_about: 'Über uns',
  footer_languages: 'Sprachen',
  footer_independent: 'Unabhängige Informationsressource. Nicht offiziell mit CSSBuy verbunden, sofern nicht ausdrücklich angegeben.',

  // Article Page
  article_breadcrumb_home: 'Startseite',
  article_breadcrumb_article: 'Artikel',
  article_related_articles: 'Verwandte Artikel',
  article_back_home: 'Zurück zur Startseite',
  article_last_updated: 'Zuletzt aktualisiert',
  article_written_by: 'Geschrieben von',
  article_author_name: 'CSSBuy Research Team',

  // 404
  notfound_title: 'Seite nicht gefunden',
  notfound_desc: 'Die gesuchte Seite existiert nicht oder wurde verschoben.',
  notfound_back: 'Zurück zur Startseite',

  // Meta
  meta_title: 'CSSBuy Spreadsheet – Produkte, Verkäufer & Einkaufsratgeber',
  meta_description: 'Entdecke ein übersichtliches CSSBuy Spreadsheet mit Produkten, Verkäufern, QC-Informationen, Versandtipps und Einkaufsratgebern.',
  meta_keywords: 'CSSBuy, CSSBuy Spreadsheet, CSSBuy Produkte, CSSBuy Verkäufer, CSSBuy Guide',
};